export interface Usuario {
  id: number;
  idPersona: number | null;
  userName: string;
  password?: string;
  isLocked: boolean;
  isActive: boolean;
  persona?: {
    idPersona: number;
    personaContacto: string;
    identificacion: string;
  };
  roles?: Rol[];
}

export interface CreateUsuarioRequest {
  userName: string;
  password: string;
  isActive: boolean;
  isLocked: boolean;
  identificacion: string;
  personaContacto: string;
  idTipoIdentificacion: number;
  idGenero: number;
  telefonoContacto?: string;
  correoContacto?: string;
}

export interface Rol {
  id: number;
  descripcion: string;
  codigo: string;
  esObligatorio: boolean;
  esOculto: boolean;
}

export interface Permiso {
  id: number;
  descripcion: string;
  codigo: string;
  esOculto: boolean;
  idModulo: number;
  modulo?: {
    id: number;
    descripcion: string;
  };
}

export const initialUsuarioState: Usuario = {
  id: 0,
  idPersona: null,
  userName: '',
  password: '',
  isLocked: false,
  isActive: true
};

export const initialCreateUsuarioRequest: CreateUsuarioRequest = {
  userName: '',
  password: '',
  isActive: true,
  isLocked: false,
  identificacion: '',
  personaContacto: '',
  idTipoIdentificacion: 1,
  idGenero: 1,
  telefonoContacto: '',
  correoContacto: ''
};

export const initialRolState: Rol = {
  id: 0,
  descripcion: '',
  codigo: '',
  esObligatorio: false,
  esOculto: false
};

export const initialPermisoState: Permiso = {
  id: 0,
  descripcion: '',
  codigo: '',
  esOculto: false,
  idModulo: 0
};
